import React from 'react';
import { 
  Box, 
  Pagination, 
  Typography, 
  FormControl,
  Select,
  MenuItem,
  Stack,
  useTheme,
  useMediaQuery
} from '@mui/material';

const PaginationComponent = ({
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 50,
  onPageChange,
  onItemsPerPageChange,
  showItemsPerPage = true,
  showInfo = true,
  itemsPerPageOptions = [10, 25, 50, 100]
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (totalPages <= 1 && !showInfo) {
    return null;
  }

  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <Box sx={{ 
      mt: 3,
      p: 2,
      backgroundColor: 'background.paper',
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider'
    }}>
      <Stack 
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        {/* Info and items per page */}
        <Stack 
          direction={{ xs: 'column', sm: 'row' }}
          alignItems="center"
          spacing={2}
        >
          {showInfo && (
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ textAlign: { xs: 'center', sm: 'left' } }}
            >
              Εμφάνιση {startItem}-{endItem} από {totalItems} αποτελέσματα
            </Typography>
          )}

          {showItemsPerPage && onItemsPerPageChange && (
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="body2" color="text.secondary">
                Ανά σελίδα:
              </Typography>
              <FormControl size="small" sx={{ minWidth: 80 }}>
                <Select
                  value={itemsPerPage}
                  onChange={(e) => onItemsPerPageChange(e.target.value)}
                  variant="outlined"
                >
                  {itemsPerPageOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
        </Stack>

        {/* Pagination */}
        {totalPages > 1 && (
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(event, page) => onPageChange && onPageChange(page)}
            color="primary"
            size={isMobile ? 'small' : 'medium'}
            showFirstButton
            showLastButton
            sx={{
              '& .MuiPagination-ul': {
                justifyContent: 'center'
              }
            }}
          />
        )}
      </Stack>
    </Box>
  );
};

export default PaginationComponent;